<ion-header>
  <ion-toolbar>
    <ion-title>{{ title | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <div *ngIf="message" [innerHTML]="message"></div>

  <ng-container *ngIf="!message">
    <h4>{{ 'Choose your notification preferences:' | translate }}</h4>
    <p>
      <strong>{{ 'NEW_OPPORTUNITIES' | translate }}</strong><br>
      {{ 'NOTIFICATION_ALL' | translate }}
    </p>
    <p>
      <strong>{{ 'AFFILIATION' | translate }}</strong><br>
      {{ 'NOTIFICATION_INFO_AFFILIATION_DESC' | translate }}
    </p>
    <p>
      <strong>{{ 'FIELD_OF_STUDY' | translate }}</strong><br>
      {{ 'NOTIFICATION_INFO_FIELD_OF_STUDY_DESC' | translate }}
    </p>
    <p>
      <strong>{{ 'OPPORTUNITY_CATEGORY' | translate }}</strong><br>
      {{ 'NOTIFICATION_INFO_CATEGORY_DESC' | translate }}
    </p>
  </ng-container>
</ion-content>